export default "__VITE_ASSET__DBrrHcDB__"